import React from 'react'
import "./Dashboard.css"
const Dashboard = () => {
  return (
   <div id="temp">dashboard</div>
  )
}

export default Dashboard
